module.exports = __webpack_public_path__ + "static/media/hot2.81a76dfc.jpg";